/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeDRadiusDownLeftIcon16Light } from './ArrowShapeDRadiusDownLeftIcon16Light';
import { ArrowShapeDRadiusDownLeftIcon16Regular } from './ArrowShapeDRadiusDownLeftIcon16Regular';
import { ArrowShapeDRadiusDownLeftIcon16Solid } from './ArrowShapeDRadiusDownLeftIcon16Solid';
import { ArrowShapeDRadiusDownLeftIcon20Light } from './ArrowShapeDRadiusDownLeftIcon20Light';
import { ArrowShapeDRadiusDownLeftIcon20Regular } from './ArrowShapeDRadiusDownLeftIcon20Regular';
import { ArrowShapeDRadiusDownLeftIcon20Solid } from './ArrowShapeDRadiusDownLeftIcon20Solid';
import { ArrowShapeDRadiusDownLeftIcon24Regular } from './ArrowShapeDRadiusDownLeftIcon24Regular';
import { ArrowShapeDRadiusDownLeftIcon24Solid } from './ArrowShapeDRadiusDownLeftIcon24Solid';
import { ArrowShapeDRadiusDownLeftIcon32Regular } from './ArrowShapeDRadiusDownLeftIcon32Regular';
import { ArrowShapeDRadiusDownLeftIcon64Regular } from './ArrowShapeDRadiusDownLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeDRadiusDownLeftIcon16Light,
        regular: ArrowShapeDRadiusDownLeftIcon16Regular,
        solid: ArrowShapeDRadiusDownLeftIcon16Solid,
    },
    20: {
        light: ArrowShapeDRadiusDownLeftIcon20Light,
        regular: ArrowShapeDRadiusDownLeftIcon20Regular,
        solid: ArrowShapeDRadiusDownLeftIcon20Solid,
    },
    24: {
        regular: ArrowShapeDRadiusDownLeftIcon24Regular,
        solid: ArrowShapeDRadiusDownLeftIcon24Solid,
    },
    32: {
        regular: ArrowShapeDRadiusDownLeftIcon32Regular,
    },
    64: {
        regular: ArrowShapeDRadiusDownLeftIcon64Regular,
    },
};
export var ArrowShapeDRadiusDownLeftIcon = forwardRef('ArrowShapeDRadiusDownLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
